<template>
  <div class="grid gap-3 sm:gap-4 sm:grid-cols-2 md:grid-cols-3" v-if="cities?.length">
    <div v-for="city in cities" :key="city.id">
      <NuxtLink :to="`/${city.slug}`" class="card">
        <div class="card__info">
          <div class="card__heading">{{ city.name }}</div>
          <AtomIcon name="chevron-right" class="card__icon" />
        </div>
      </NuxtLink>
    </div>
    <button class="card" @click="goToFat">
      <div class="card__info">
        <div class="card__heading">{{ $t('shared.allCities') }}</div>
        <AtomIcon name="chevron-right" class="card__icon" />
      </div>
    </button>
  </div>
</template>

<script async setup>
const app = useAppStore()
const router = useRouter()

const popularCities = computed(() => app.cities
  .filter(city => city?.sections)
  .slice(0, 3))

const otherCities = computed(() => app.cities
  .filter(city => city?.sections)
  .slice(3)
  .sort((a, b) => a.name.localeCompare(b.name, 'sv')))

const cities = computed(() => [...popularCities.value, ...otherCities.value])

// Push FAT route instead of using indexable link (force Sthlm with location modal)
const goToFat = () => {
  router.push({ name: 'fat', query: { cityId: 86915, locationModal: true }})
}
</script>

<style lang="scss" scoped>
.card {
  @apply block bg-mist text-black rounded p-3 sm:p-4;

  &__info {
    @apply flex items-center justify-between;
  }

  &__heading {
    @apply font-heading font-medium text-xl;
  }

  &__icon {
    @apply text-lg text-coral;
  }
}
</style>